/* eslint-disable max-len */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import TextField from '../../widgets/TextField';
import CheckBoxField from '../../widgets/CheckBoxField';

import './subscribe-form.scss';

class SubscribeForm extends PureComponent {
  render() {
    return (
      <div className="subscribe-form-container">
        <h3>Инвестиционный <br/>клуб USC</h3>

        <p>&laquo;Юнисервис Капитал&raquo; регулярно собирает, пишет и&nbsp;оформляет новости для своих инвесторов. В&nbsp;дайджест попадают только важные события: планируемые и&nbsp;текущие долговые программы, отчеты о&nbsp;работе &laquo;Юнисервис Капитал&raquo;, новости от&nbsp;наших эмитентов, в&nbsp;том числе об&nbsp;использовании привлеченных инвестиций и&nbsp;финансовых показателях.</p>

        <p>Если вы&nbsp;хотите регулярно получать новости нашего инвестиционного клуба&nbsp;&mdash; заполните форму обратной связи.</p>

        <form className="login-form" onSubmit={this.props.onSubmit}>
          <TextField
            id="loginForm_name"
            label="Имя"
            type="text"
            name="name"
            value={this.props.name}
            error={this.props.nameError}
            onChange={this.props.onFieldChange}
          />

          <TextField
            id="loginForm_surname"
            label="Фамилия"
            type="text"
            name="surname"
            value={this.props.surname}
            error={this.props.surnameError}
            onChange={this.props.onFieldChange}
          />

          <TextField
            id="loginForm_company"
            label="Компания"
            type="text"
            name="company"
            value={this.props.company}
            error={this.props.companyError}
            onChange={this.props.onFieldChange}
          />

          <TextField
            id="loginForm_login"
            label="Email"
            type="text"
            name="email"
            value={this.props.email}
            error={this.props.emailError}
            onChange={this.props.onFieldChange}
          />

          <CheckBoxField
            id="loginForm_agreement"
            label="Согласие на обработку персональных данных"
            name="agreement"
            checked={this.props.agreement}
            error={this.props.agreementError}
            onChange={this.props.onAgreementChange}
          />

          <div className="submit-container">
            <button type="submit" className="btn solid-white">
              <div className="btn-flex">
                <em>Рассылка новостей<span className="icon">→</span></em>
                Подписаться
              </div>
            </button>
          </div>
        </form>
      </div>
    );
  }
}

SubscribeForm.propTypes = {
  name: PropTypes.string.isRequired,
  nameError: PropTypes.string,
  surname: PropTypes.string.isRequired,
  surnameError: PropTypes.string,
  company: PropTypes.string.isRequired,
  companyError: PropTypes.string,
  email: PropTypes.string.isRequired,
  emailError: PropTypes.string,
  agreement: PropTypes.bool.isRequired,
  agreementError: PropTypes.string,
  onFieldChange: PropTypes.func.isRequired,
  onAgreementChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default SubscribeForm;



// WEBPACK FOOTER //
// ./src/components/Layout/Navigation/SubscribeForm.js